import styled from 'styled-components'

// eslint-disable-next-line no-undef
export const FormControlWrapperTS = styled("div")<{smallGap: boolean}>`
  position: relative;
  max-width: 360px;
  margin-bottom: ${(props) => (props.smallGap ? '24px;' : '48px;')}   

  input:before {
    content: '\f00c';
  }
`
